import React from 'react';
import { FaBriefcase, FaClipboardCheck, FaIndustry } from 'react-icons/fa';
import { StatsGrid, StatCard } from './Stats.styles';

const Stats = () => {
  return (
    <>
      <StatsGrid>
        <StatCard>
          <FaBriefcase />
          <strong>25+ Years</strong>
          <span>Industry Experience</span>
        </StatCard>

        <StatCard>
          <FaClipboardCheck />
          <strong>3500+ Audits</strong>
          {/* <span>Completed for within Provincial and Federal jurisdictions</span> */}
          <span>Completed using approved WCB Nova Scotia standards.</span>
        </StatCard>

        <StatCard>
          <FaIndustry />
          <strong>25+ Years</strong>
          <span>Manufacturing Experience </span>
        </StatCard>
      </StatsGrid>
    </>
  );
};

export default Stats;
